const { doAction, fail, success } = require('./index');

const FAILED_CREATE_MESSAGE = 'Failed to create a new classroom';
const SUCCEEDED_CREATE_MESSAGE = 'Classroom created';
const CREATED_CLASSROOM = 'CREATED_CLASSROOM';
const CREATING_CLASSROOM = 'CREATING_CLASSROOM';

const FAILED_DELETE_MESSAGE = 'Deletion failed';
const SUCCEEDED_DELETE_MESSAGE = 'Classroom deleted';
const DELETED_CLASSROOM = 'DELETED_CLASSROOM';
const DELETING_CLASSROOM = 'DELETING_CLASSROOM';

const FAILED_FETCH_MESSAGE =
	'Failed to retrieve the list of classrooms from the server';
const FETCHED_CLASSROOMS = 'FETCHED_CLASSROOMS';
const FETCHING_CLASSROOMS = 'FETCHING_CLASSROOMS';
const FETCHED_CLASSROOM = 'FETCHED_CLASSROOM';
const FETCHING_CLASSROOM = 'FETCHING_CLASSROOM';

const FAILED_FETCHING_INSTRUCTORS_MESSAGE =
	'Failed to retrieve the list of instructors from the server';
const FETCHED_INSTRUCTORS = 'FETCHED_INSTRUCTORS';
const FETCHING_INSTRUCTORS = 'FETCHING_INSTRUCTORS';

const FAILED_GROUPING_STUDENTS_MESSAGE = 'Failed to group students';
const SUCCEEDED_GROUPING_STUDENTS_MESSAGE =
	'Students were successfully grouped';
const GROUPED_STUDENTS = 'GROUPED_STUDENTS';
const GROUPING_STUDENTS = 'GROUPING_STUDENTS';

const FAILED_UPDATE_MESSAGE = 'Update failed';
const SUCCEEDED_UPDATE_MESSAGE = 'Classroom updated';
const UPDATED_CLASSROOM = 'UPDATED_CLASSROOM';
const UPDATING_CLASSROOM = 'UPDATING_CLASSROOM';

const SELECT_CLASSROOM = 'SELECT_CLASSROOM';

const url = '/api/classrooms';

const fetchClassroom = function(classroomId) {
	const fetchUrl = `${ url }/${ classroomId }`;
	const method = 'get';
	const payload = null;
	const doingActionType = FETCHING_CLASSROOM;
	const didActionType = FETCHED_CLASSROOM;
	const failureMessage = FAILED_FETCH_MESSAGE;
	const successMessage = null;
	const getSuccessPayload = responseJson => ({
		classroom: responseJson.data.classroom
	});

	return doAction(
		fetchUrl,
		method,
		payload,
		doingActionType,
		didActionType,
		failureMessage,
		successMessage,
		getSuccessPayload
	);
};

module.exports = {
	FAILED_CREATE_MESSAGE,
	CREATED_CLASSROOM,
	CREATING_CLASSROOM,

	FAILED_DELETE_MESSAGE,
	DELETED_CLASSROOM,
	DELETING_CLASSROOM,

	FAILED_FETCH_MESSAGE,
	FETCHED_CLASSROOMS,
	FETCHING_CLASSROOMS,
	FETCHED_CLASSROOM,
	FETCHING_CLASSROOM,

	FETCHED_INSTRUCTORS,
	FETCHING_INSTRUCTORS,

	GROUPED_STUDENTS,
	GROUPING_STUDENTS,

	FAILED_UPDATE_MESSAGE,
	UPDATED_CLASSROOM,
	UPDATING_CLASSROOM,

	SELECT_CLASSROOM,

	createClassroom(classroom) {
		const method = 'post';
		const payload = classroom;
		const doingActionType = CREATING_CLASSROOM;
		const didActionType = CREATED_CLASSROOM;
		const failureMessage = FAILED_CREATE_MESSAGE;
		const successMessage = SUCCEEDED_CREATE_MESSAGE;
		const getSuccessPayload = responseJson => ({
			list: responseJson.data.list,
			classroom: responseJson.data.classroom
		});

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage,
			getSuccessPayload
		);
	},

	deleteClassroom(classroomId) {
		const method = 'delete';
		const payload = { id: classroomId };
		const doingActionType = DELETING_CLASSROOM;
		const didActionType = DELETED_CLASSROOM;
		const failureMessage = FAILED_DELETE_MESSAGE;
		const successMessage = SUCCEEDED_DELETE_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	},

	fetchClassrooms() {
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_CLASSROOMS;
		const didActionType = FETCHED_CLASSROOMS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	},

	fetchClassroomsBySchool(schoolId) {
		const endpoint = `${ url }?school_id=${ schoolId }`;
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_CLASSROOMS;
		const didActionType = FETCHED_CLASSROOMS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			endpoint,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	},

	fetchClassroomsByDistrict(districtId) {
		const endpoint = `${ url }?district_id=${ districtId }`;
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_CLASSROOMS;
		const didActionType = FETCHED_CLASSROOMS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			endpoint,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	},

	fetchClassroom,

	fetchInstructors(classroomId) {
		const groupUrl = `${ url }/${ classroomId }/instructors`;
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_INSTRUCTORS;
		const didActionType = FETCHED_INSTRUCTORS;
		const failureMessage = FAILED_FETCHING_INSTRUCTORS_MESSAGE;

		return doAction(
			groupUrl,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	},

	groupStudents(classroomId) {
		const groupUrl = `${ url }/group_students`;
		const method = 'post';
		const payload = { id: classroomId };
		const doingActionType = GROUPING_STUDENTS;
		const didActionType = GROUPED_STUDENTS;
		const failureMessage = FAILED_GROUPING_STUDENTS_MESSAGE;
		const successMessage = SUCCEEDED_GROUPING_STUDENTS_MESSAGE;
		const getSuccessPayload = responseJson => ({
			classroom: responseJson.data.classroom
		});

		return doAction(
			groupUrl,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage,
			getSuccessPayload
		);
	},

	selectClassroom(classroom) {
		return {
			type: SELECT_CLASSROOM,
			payload: {
				classroom
			}
		};
	},

	updateClassroom(classroom) {
		const method = 'PATCH';
		const payload = classroom;
		const doingActionType = UPDATING_CLASSROOM;
		const didActionType = UPDATED_CLASSROOM;
		const failureMessage = FAILED_UPDATE_MESSAGE;
		const successMessage = SUCCEEDED_UPDATE_MESSAGE;
		const getSuccessPayload = responseJson => ({
			list: responseJson.data.list,
			classroom: responseJson.data.classroom
		});

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage,
			getSuccessPayload
		);
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/classrooms.js